import api from './api';
import createTracker, { createClient } from '../middleware/launchdarkly';
import {
  AUTHENTICATION_INVALIDATE,
  AUTHENTICATION_SUCCESS
} from '../../actions/api/auth';
import { reset, identify } from '../../selectors/feature';
import ENV from '../../env';

export function relay(dispatch, state, action) {
  // eslint-disable-next-line no-unused-vars
  const { type, payload, response = {} } = action;

  switch (type) {
    case AUTHENTICATION_INVALIDATE:
      dispatch(reset(state));
      return;
    case api.INITIALIZE:
      dispatch(identify(state));
      return;
    case AUTHENTICATION_SUCCESS:
      // Session entity doesn't exist, so pull the user out of the
      // response
      const { result: id, entities: { users = {} } = {} } = response;
      const session = users[id];
      dispatch(identify({ session }));

    default:
  }
}

const tracker = createTracker(relay, createClient(ENV.PUSHBOT_LAUNCHDARKLY_ID));

export default tracker;



// WEBPACK FOOTER //
// ./js/store/config/feature.js